export const MENUS = {
  loans: {
    parentPath: "loans",
    name: "Loans",
    routerPath: "loans"
  },
  reports: {
    parentPath: "reports",
    name: "Reports",
    routerPath: "reports"
  },
  profile: {
    parentPath: "profile",
    name: "My Profile",
    routerPath: "profile"
  },
  faqs: {
    parentPath: "faqs",
    name: "FAQs",
    routerPath: "faqs"
  },
  accounts: {
    parentPath: 'accounts',
    name: 'My Account',
    routerPath: '#',
    subMenus: [
      { name: 'Update Profile', routerPath: '#' },
      { name: 'History', routerPath: '#' },
      { name: 'View Mortgage Statements', routerPath: '#' },
      { name: 'Year to Date', routerPath: '#' },
      { name: 'Year End (1098)', routerPath: '#' },
      { name: 'Amortization Schedule', routerPath: '#' }
    ]
  },
  payments: {
    parentPath: 'payments',
    name: 'Make a Payment',
    routerPath: 'make-a-payment',
    subMenus: [
      { name: 'Pay Online', routerPath: 'pay-online' },
      { name: 'Auto Draft', routerPath: 'auto-draft' },
      { name: 'Coupon Book', routerPath: 'coupon-book' },
      { name: 'Payoff Request', routerPath: 'payoff-request' }
    ]
  },

  // TODO ACMD-80: Won't be able to use the menu object for the sidenav until we figure out how to use nested routerLinks. Hardcoded the Lending Options sidenav for the time being.
  lending: {
    parentPath: 'lending',
    name: 'Lending Options',
    routerPath: 'lending-options',
    subMenus: []
  },

  // TODO ACMD-80: Won't be able to use the menu object for the sidenav until we figure out how to use nested routerLinks. Hardcoded the Resource Center sidenav for the time being.
  resources: {
    parentPath: 'resources',
    name: 'Resource Center',
    routerPath: 'resource-center',
    subMenus: [
      {
        name: 'Calculators',
        routerPath: 'calculators'
        // subMenus: [
        //   { name: 'Should I refinance?', routerPath: 'refinance'},
        //   { name: 'How much will my fixed rate mortgage payment be?', routerPath: 'fixed-rate'},
        //   { name: 'How much will my adjustable rate mortgage payments be?', routerPath: 'adjustable-rate'},
        //   { name: 'How much will my payments be for a balloon mortgage?', routerPath: 'balloon'},
        //   { name: 'Should I rent or buy?', routerPath: 'rent-or-buy'},
        //   { name: 'Which mortgage is better for me?', routerPath: 'which-mortgage'},
        //   { name: 'How much will I save by increasing my mortgage payment?', routerPath: 'savings'},
        //   { name: 'How much mortgage might I qualify for?', routerPath: 'qualify'},
        //   { name: 'How much home can I afford?', routerPath: 'afford'},
        //   { name: 'Should I consolidate my loans?', routerPath: 'consolidate'},
        // ]
      },
      { name: 'Ask Arvest', routerPath: 'ask-arvest' },
      { name: 'Glossary', routerPath: 'glossary' },
      {
        name: 'Hardship Assistance', routerPath: 'hardship-assistance'
        // subMenus: [
        //   { name: 'Current Status', routerPath: 'current-status' },
        //   { name: 'Hardship Assistance Request', routerPath: 'hardship-assistance-request'}
        // ]
      },
      { name: 'Mortgage Fee Schedule', routerPath: 'mortgage-fee' },
      { name: 'Servicemembers Civil Relief Act (SCRA)', routerPath: 'scra' },
      { name: 'Insurance Claims', routerPath: 'insurance-claims' },
      { name: 'Title Company Requests', routerPath: 'title-company-requests' }
    ]
  },

  privacy: {
    parentPath: 'privacy-policy',
    name: 'Privacy Policy',
    routerPath: 'privacy-policy',
    subMenus: [
      { name: 'Questions & Answers', routerPath: 'questions-and-answers' },
      { name: 'Opt-Out Form', routerPath: 'opt-out' },
      { name: 'Do Not Call Form', routerPath: 'do-not-call' }
    ]
  }
};
